import throttle from 'lodash/throttle';

import { getScreenWidth } from './getScreenWidth.js';

const sortComparatorAscending = (a, b) => a - b;

function findPositionInArray(array, value) { // If it were in array
  return [...array, value]
    .sort(sortComparatorAscending)
    .indexOf(value);
}

// Callback is called only when width passes a breakpoint.
// The throttle must keep its trailing call: iPad Safari fires a burst of resizes when the tab comes back from
// the background, and only the last one carries the real width. Dropping it left the navbar laid out for a
// transient width - "Log in" and "List your space" folded into the avatar menu on a landscape tablet.
export function addResizeListener(breakpoints, callback) {
  // The navbar has just been built for the current width, so only a later crossing needs a rebuild.
  let previousWidthIndex = findPositionInArray(breakpoints, getScreenWidth());

  const onResize = throttle(() => {
    const width = getScreenWidth();
    const widthIndex = findPositionInArray(breakpoints, width);

    if (widthIndex === previousWidthIndex) {
      return;
    }
    previousWidthIndex = widthIndex;
    callback();
  }, 200);

  window.addEventListener('resize', onResize);
  // A width change made while the page was hidden does not always come with a resize once it is shown again.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      onResize();
    }
  });
}
